var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"},[_c('md-card',[_c('md-card-content',[_c('b-container',{attrs:{"fluid":""}},[_c('bemor-form')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }